import { render, staticRenderFns } from "./website-cms-detail.vue?vue&type=template&id=5c798eff&scoped=true&"
import script from "./website-cms-detail.vue?vue&type=script&lang=js&"
export * from "./website-cms-detail.vue?vue&type=script&lang=js&"
import style0 from "./website-cms-detail.vue?vue&type=style&index=0&id=5c798eff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c798eff",
  null
  
)

export default component.exports